'use client'

import { useTranslations } from 'next-intl'
import Link from 'next/link'
import InfoCard from './info-card'
import SectionHeader from './section-header'

export default function InnovativeMaterials() {
  const t = useTranslations('page_cam_ket_phat_trien')
  return (
    <div id='item-3-content'>
      <SectionHeader
        number='03'
        title={t.rich('innovative.title', {
          brMd: () => <br className='hidden md:block' />,
        })}
      />
      <div className='grid gap-5 md:grid-cols-3'>
        <InfoCard
          imageSrc='https://media.coolmate.me/image/October2024/mceclip0_89.png'
          imageAlt={t('innovative.card_1.alt')}
          title={
            <Link
              href='/page/cleanvn/'
              className='mb-3 inline-flex items-center gap-1 font-criteria text-lg font-medium text-primary md:text-xl'
            >
              {t('innovative.card_1.title')} <span>↗</span>
            </Link>
          }
          description={t('innovative.card_1.description')}
        />
        <InfoCard
          imageSrc='https://media.coolmate.me/image/October2024/mceclip2_67.png'
          imageAlt={t('innovative.card_2.alt')}
          title={
            <Link
              href='/page/cleandye/'
              className='mb-3 inline-flex items-center gap-1 font-criteria text-lg font-medium text-primary md:text-xl'
            >
              {t('innovative.card_2.title')} <span>↗</span>
            </Link>
          }
          description={t('innovative.card_2.description')}
        />
        <InfoCard
          imageSrc='https://media.coolmate.me/image/October2024/mceclip3_99.png'
          imageAlt={t('innovative.card_3.alt')}
          title={
            <Link
              href='/collection/excool'
              className='mb-3 inline-flex items-center gap-1 font-criteria text-lg font-medium text-primary md:text-xl'
            >
              {t('innovative.card_3.title')} <span>↗</span>
            </Link>
          }
          description={t('innovative.card_3.description')}
        />
      </div>
    </div>
  )
}
